import { render, staticRenderFns } from "./Navbarcalendarcrm.vue?vue&type=template&id=2d313d0a&"
import script from "./Navbarcalendarcrm.vue?vue&type=script&lang=js&"
export * from "./Navbarcalendarcrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports